// There is a ticket to refactor the routes in routes.tsx to use route constants defined here https://montugroup.atlassian.net/browse/UMED-8292
// Identity routes
export const ROOT_ROUTE = '/' as const;
export const LOGIN_ROUTE = '/login' as const;
export const LOGIN_ONBOARDKEY_ROUTE = '/login/:onBoardKey' as const;
export const LOGOUT_ROUTE = '/logout' as const;
export const PASSWORD_ROUTE = '/password' as const;
export const FORGOT_PASSWORD_ROUTE = '/forgot-password' as const;
export const RESET_PASSWORD_ROUTE = '/reset-password' as const;
export const RESET_PASSWORD_LEGACY_ROUTE = '/reset-password/:id' as const;
export const HEALTH_CHECK_ROUTE = '/health-check' as const;
export const ONBOARD_ROUTE = '/onboard/:token' as const;

export const POLICY_ROUTE = '/policy' as const;
export const PROFILE_DETAIL_ROUTE = '/profile-detail' as const;
export const INVENTORY_ROUTE = '/inventory' as const;
export const ORDERS_ROUTE = '/orders' as const;
export const SHIPMENTS_ROUTE = '/shipments' as const;
export const SHIPMENT_ACKNOWLEDGEMENT_ROUTE = '/shipments/:id' as const;
export const ESCRIPT_ROUTE = '/escript' as const;
